import { Filter } from '@anytag/shared-molecules';
import { BasicFilter } from './BasicFilter';
import { useTikTokCampaignInfluencersFilter } from './hooks';

export const TikTokCampaignInfluencersFilter = () => {
  const { filter, setFilterForm } = useTikTokCampaignInfluencersFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter} className="rounded-none">
      <BasicFilter />
    </Filter.Provider>
  );
};

export { useTikTokCampaignInfluencersFilter };
export * from './schemaTypes';
